import type en from './en.json'

export type Translations = typeof en

// Helper type to flatten nested object keys with dot notation
type FlattenKeys<T, Prefix extends string = ''> = T extends object
  ? {
      [K in keyof T]: K extends string
        ? T[K] extends object
          ? FlattenKeys<T[K], `${Prefix}${K}.`>
          : `${Prefix}${K}`
        : never
    }[keyof T]
  : never

export type TranslationKey = FlattenKeys<Translations>

export type Locale = 'en' | 'de' | 'af'

export const LOCALES: Record<Locale, string> = {
  en: 'English',
  de: 'Deutsch',
  af: 'Afrikaans',
}

export const DEFAULT_LOCALE: Locale = 'en'
export const LOCALE_STORAGE_KEY = 'justsell-locale'
